import * as React from 'react';
const SvgCrossSquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M14.121 8.465a1 1 0 1 1 1.415 1.414L13.414 12l2.122 2.122a1 1 0 0 1-1.415 1.414L12 13.415l-2.121 2.12a1 1 0 1 1-1.415-1.413L10.586 12 8.464 9.88A1 1 0 1 1 9.88 8.465L12 10.586z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.36 4.33c.56.29 1.02.75 1.31 1.31.33.64.33 1.48.33 3.16v6.4c0 1.68 0 2.52-.33 3.16-.29.56-.75 1.02-1.31 1.31-.64.33-1.48.33-3.16.33H8.8c-1.68 0-2.52 0-3.16-.33-.56-.29-1.02-.75-1.31-1.31C4 17.72 4 16.88 4 15.2V8.8c0-1.68 0-2.52.33-3.16.29-.56.75-1.02 1.31-1.31C6.28 4 7.12 4 8.8 4h6.4c1.68 0 2.52 0 3.16.33m-.47 13.12c.11-.21.11-1.25.11-2.25V8.8c0-1 0-2.04-.11-2.25-.1-.19-.25-.34-.44-.44C17.24 6 16.2 6 15.2 6H8.8c-1 0-2.04 0-2.25.11-.19.1-.34.25-.44.44C6 6.76 6 7.8 6 8.8v6.4c0 1 0 2.04.11 2.25.1.19.25.34.44.44.21.11 1.25.11 2.25.11h6.4c1 0 2.04 0 2.25-.11.19-.1.34-.25.44-.44"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCrossSquare;
